/* eslint-disable no-case-declarations */
import _ from 'lodash';
import { combineReducers } from 'redux';
import {
  CataloguePayloadModel,
  CurrentCatalogueErrorsModel,
  CurrentStoreListingErrorModel,
  StoreListingPayloadModel,
} from 'src/models';
import { PublisherActionTypes } from 'src/store/actions/publisher.action';
import {
  CatalogueManagerStateModel,
  OtsManagerStateModel,
  StoreManagerStateModel,
} from 'src/store/initial.state';

const CatalogueManagerReducer = (state = new CatalogueManagerStateModel(), { type, payload }) => {
  switch (type) {
    case PublisherActionTypes.ADD_USERID:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          createdBy: payload,
        },
      };

    case PublisherActionTypes.GET_ALL_LIVE_BATCHES:
      console.log(payload);
      return { ...state, batches: payload.data.data };

    case PublisherActionTypes.MODIFY_CTALOGUE_SUBJECT_LIST:
      return {
        ...state,
        catalogueSubjectList: _.cloneDeep([...payload]),
      };

    case PublisherActionTypes.MODIFY_STUDENT_RESOURCE:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          resources: [...payload],
        },
      };

    //

    case PublisherActionTypes.ADD_OR_UPDATE_CATEGORY:
      return {
        ...state,
      };

    case PublisherActionTypes.DELETE_CATEGORY_BY_ID:
      return {
        ...state,
      };

    case PublisherActionTypes.DELETE_CATALOGUE_BY_ID:
      return {
        ...state,
      };

    case PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_ADDONS:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          addOns: [...payload],
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_SUBJECTS:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          subjects: [...payload],
        },
      };

    case PublisherActionTypes.MODIFY_CATALOGUE_SUBSCRIPTION:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          subscriptions: [...payload],
        },
      };

    case PublisherActionTypes.FLUSH_CURRENT_CATALOGUE_STATE:
      return {
        ...state,
        currentCatalogueInfo: '',
        currentCatalogueInfoPayload: new CataloguePayloadModel(),
        currentCatalogueErrors: new CurrentCatalogueErrorsModel(),
        isSubmit: false,
      };

    case PublisherActionTypes.SET_CURRENT_CATALOGUEID_PAYLOAD:
      return {
        ...state,
        currentCatalogueInfoPayload: payload,
      };

    case PublisherActionTypes.SET_CURRENT_CATALOGUE_ID:
      return {
        ...state,
        currentCatalogueId: payload,
      };

    case PublisherActionTypes.GET_CATALOGUE_LIST:
      return {
        ...state,
        catalogueList: payload.data,
      };

    case PublisherActionTypes.GET_CATALOGUE_SUBJECTS:
      return {
        ...state,
        catalogueSubjectList: _.cloneDeep([...payload.data]),
      };

    case PublisherActionTypes.GET_CURRENT_CATALOGUE_SUBJECTS:
      return {
        ...state,
        curentCatalogueSubjectList: [...payload.data],
      };

    case PublisherActionTypes.GET_CURRENT_CATALOGUE_ID_DATA:
      return {
        ...state,
        currentCatalogueInfo: { ...payload.data },
      };

    case PublisherActionTypes.MODIFY_CATALOGUE_CATALOGUEINFO:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          // category: { ...payload.categoryFormState },
          catalogueInfo: { ...payload.catalogueInfoFormState },
        },
        isSubmit: payload.isSubmit,
      };

    case PublisherActionTypes.MODIFY_CATALOGUE_THEME:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          catalogueTheme: { ...payload },
        },
      };

    case PublisherActionTypes.MODIFY_CATALOGUE_PUBLISHER:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          cataloguePublisher: { ...payload },
        },
      };

    case PublisherActionTypes.ADD_STEPPER_ERRORS:
      return {
        ...state,
        currentCatalogueErrors: {
          ...state.currentCatalogueErrors,
          [payload.key]: payload.value,
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_STAKEHOLDERS:
      return {
        ...state,
        currentCatalogueInfoPayload: {
          ...state.currentCatalogueInfoPayload,
          publishingInfo: { ...payload },
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_FORM_SUBMIT:
      return {
        ...state,
        isSubmit: true,
      };

    default:
      return {
        ...state,
      };
  }
};

const StoreManagerReducer = (state = new StoreManagerStateModel(), { type, payload }) => {
  switch (type) {
    case PublisherActionTypes.SAVE_ALL_RECOMMENDED_COURSES:
      return { ...state, recommendationCourses: payload };

    case PublisherActionTypes.SAVE_RECOMMENDED_COURSES:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          recommendationCourses: payload,
        },
      };

    case PublisherActionTypes.MODIFY_TESTIMONIAL: {
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          testimonials: payload,
        },
      };
    }

    case PublisherActionTypes.MODIFY_FAQ: {
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          faqs: payload,
        },
      };
    }
    case PublisherActionTypes.MODIFY_QUESTION_PAPER: {
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          questionPapers: payload,
        },
      };
    }
    case PublisherActionTypes.MODIFY_SEO_RELATED_INFO: {
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          dynamicMetadataSEOInfo: payload,
        },
      };
    }
    case PublisherActionTypes.CREATE_STORE_LISTING:
      return {
        ...state,
      };

    case PublisherActionTypes.UPDATE_STORE_LISTING:
      return {
        ...state,
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SUBSCRIPTION:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          subscriptions: [..._.cloneDeep(payload)],
        },
      };

    case PublisherActionTypes.MODIFY_STORE_LISTING_STOREINFO:
      return {
        ...state,
        // currentCatalogueInfoPayload: {
        //     ...state.currentCatalogueInfoPayload,
        //     // category: { ...payload.categoryFormState },
        //     catalogueInfo: { ...payload.catalogueInfoFormState }
        // },
        isSubmit: payload.isSubmit,
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_ADDONS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          addons: [...payload],
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PREVIEW_VIDEOS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          previewVideos: [...payload],
        },
      };

    case PublisherActionTypes.ADD_STORE_LISTING_STEPPER_ERRORS:
      return {
        ...state,
        currentStoreStepsError: {
          ...state.currentStoreStepsError,
          [payload.key]: payload.value,
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CATALOGUE:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeListingId: payload.storeId || state.currentStoreListingPayload.storeListingId,
          storeListingName: '',
          sameNameAsCatalogue: false,
          catalogueId: payload.catalogueId,
          catalogueName: payload.catalogueName,
          catalogueCode: payload.catalogueCode,
        },
      };

    case PublisherActionTypes.MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_NAME:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          sameNameAsCatalogue: payload,
          storeListingName:
            payload === true
              ? state.currentStoreListingPayload.catalogueName
              : state.currentStoreListing.storeListingName,
        },
      };

    case PublisherActionTypes.MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_HOURS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          sameAsCatalogueHours: payload,
          storeListingHours:
            payload === true
              ? state.currentStoreListing.cataloguesTotalNoOfHours
              : state.currentStoreListing.storeListingHours,
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_NAME:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeListingName: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CODE:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeListingCode: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_DESCRIPTION:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeListingDescription: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SYLLABUS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          examSyllabus: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PROGRAMS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          programs: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_STORE_ICON:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeIconUrl: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_EXAM_PATTERN:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          examPattern: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PREPARATION_TIPS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          preparationTips: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_STUDENT_TARGET_YEAR:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          studentTargetYear: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_HOURS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          storeListingHours: Number(payload),
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_FEATURED_ON_LEADS:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          featuredOnLeadPage: payload,
        },
      };
    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CATEGORY:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          category: {
            categoryId: payload.categoryId,
            categoryName: payload.categoryName,
            subCategory: {
              subCategoryId: '',
              subCategoryName: '',
            },
          },
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SUBCATEGORY:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          category: {
            ...state.currentStoreListingPayload.category,
            subCategory: {
              subCategoryId: payload.subCategoryId,
              subCategoryName: payload.subCategoryName,
            },
          },
        },
      };

    case PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_STUDENT_TARGET_YEAR:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          studentTargetYear: payload,
        },
      };

    case PublisherActionTypes.ADD_CREATED_BY_TO_STORE_LISTING:
      return {
        ...state,
        currentStoreListingPayload: {
          ...state.currentStoreListingPayload,
          createdBy: payload,
        },
      };

    case PublisherActionTypes.GET_STORE_LISTING_BY_ID:
      return {
        ...state,
        currentStoreListing: payload.data,
      };

    case PublisherActionTypes.GENERATE_CURRENT_STORE_LISTING_PAYLOAD:
      return {
        ...state,
        currentStoreListingPayload: payload,
      };

    case PublisherActionTypes.FLUSH_CURRENT_STORE_LISTING_STATE:
      return {
        ...state,
        currentStoreListing: '',
        currentStoreListingPayload: new StoreListingPayloadModel(),
      };

    case PublisherActionTypes.GET_ALL_STORE_LISTING:
      return {
        ...state,
        storeList: payload.data,
      };

    case PublisherActionTypes.GET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: payload.data,
      };

    case PublisherActionTypes.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: payload,
      };

    case PublisherActionTypes.SET_SELECTED_SUBCATEGORY:
      return {
        ...state,
        selectedSubCategory: payload,
      };

    case PublisherActionTypes.SET_STORE_LISTINGS:
      return {
        ...state,
        selectedStoreList: payload,
      };

    case PublisherActionTypes.FLUSH_CURRENT_STORE_LISTING_ERRORS:
      return {
        ...state,
        currentStoreStepsError: new CurrentStoreListingErrorModel(),
      };

    default:
      return {
        ...state,
      };
  }
};
// Ots Manager
const OtsManagerReducer = (state = new OtsManagerStateModel(), { type, payload }) => {
  switch (type) {
    case PublisherActionTypes.GET_ALL_OTS_CATALOGUE:
      return {
        ...state,
        otsCatalogueList: payload.data,
      };

    case PublisherActionTypes.GET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: payload.data,
      };

    case PublisherActionTypes.GENERATE_CURRENT_OTS_SUBSCRIPTION_LIST:
      const payload1 = JSON.parse(JSON.stringify(payload.data));
      const payload2 = JSON.parse(JSON.stringify(payload.data));
      return {
        ...state,
        subscriptionsList: payload1,
        backupSubscriptionList: payload2,
      };

    case PublisherActionTypes.FLUSH_CURRENT_OTS_SUBSCRIPTION_LIST:
      return {
        ...state,
        subscriptionsList: [],
      };

    case PublisherActionTypes.MODIFY_PRODUCT_TO_SUBSCRIPTION_BY_ID:
      return {
        ...state,
        subscriptionsList: payload,
      };

    case PublisherActionTypes.ADD_PRODUCT_TO_SUBSCRIPTION_BY_ID:
      const newSubscriptionListAdd = [...state.subscriptionsList];
      const subscriptionIndexAdd = newSubscriptionListAdd.findIndex(
        subscription => subscription.subscriptionId === payload.id
      );

      newSubscriptionListAdd[subscriptionIndexAdd] = {
        ...newSubscriptionListAdd[subscriptionIndexAdd],
        otsList: [...newSubscriptionListAdd[subscriptionIndexAdd].otsList, payload.newRow],
      };
      return {
        ...state,
        subscriptionsList: newSubscriptionListAdd,
      };

    case PublisherActionTypes.DISCARD_CHANGES_IN_SUBSCRIPTION_BY_ID:
      const newSubscriptionListDiscard = [...state.subscriptionsList];
      const backupSubscriptionListDiscard = [...state.backupSubscriptionList];

      const subscriptionIndexDiscard = newSubscriptionListDiscard.findIndex(
        subscription => subscription.subscriptionId === payload.subscriptionId
      );
      const backupSubscriptionIndexDiscard = backupSubscriptionListDiscard.findIndex(
        subscription => subscription.subscriptionId === payload.subscriptionId
      );

      newSubscriptionListDiscard[subscriptionIndexDiscard] = {
        ...newSubscriptionListDiscard[subscriptionIndexDiscard],
        otsList: [...backupSubscriptionListDiscard[backupSubscriptionIndexDiscard].otsList],
      };

      const originalSubscriptionList = JSON.parse(JSON.stringify(newSubscriptionListDiscard));

      return {
        ...state,
        subscriptionsList: [...originalSubscriptionList],
      };

    case PublisherActionTypes.DELETE_PRODUCT_TO_SUBSCRIPTION_BY_ID:
      const newSubscriptionListDelete = [...state.subscriptionsList];
      const selectedSubscriptionIndex = newSubscriptionListDelete.findIndex(
        subscription => subscription.subscriptionId === payload.subscriptionId
      );
      const selectedOtsIndex = newSubscriptionListDelete[
        selectedSubscriptionIndex
      ].otsList.findIndex(ots => ots.otsId === payload.otsId);

      if (
        newSubscriptionListDelete[selectedSubscriptionIndex].otsList[selectedOtsIndex].status ===
        'CREATED'
      ) {
        const filteredOts = newSubscriptionListDelete[selectedSubscriptionIndex].otsList.filter(
          ots =>
            ots.otsId !==
            newSubscriptionListDelete[selectedSubscriptionIndex].otsList[selectedOtsIndex].otsId
        );
        newSubscriptionListDelete[selectedSubscriptionIndex] = {
          ...newSubscriptionListDelete[selectedSubscriptionIndex],
          otsList: [...filteredOts],
        };
      } else {
        newSubscriptionListDelete[selectedSubscriptionIndex].otsList[selectedOtsIndex].status =
          'DELETED';
      }

      const updatedSubscriptionListDelete = JSON.parse(JSON.stringify(newSubscriptionListDelete));

      return {
        ...state,
        subscriptionsList: [...updatedSubscriptionListDelete],
      };

    case PublisherActionTypes.UPDATE_PRODUCT_IN_SUBSCRIPTION_BY_ID:
      const newSubscriptionListUpdate = [...state.subscriptionsList];
      const updatedSubscriptionIndex = newSubscriptionListUpdate.findIndex(
        subscription => subscription.subscriptionId === payload.subscriptionId
      );
      const updatedOtsIndex = newSubscriptionListUpdate[updatedSubscriptionIndex].otsList.findIndex(
        ots => ots.otsId === payload.otsId
      );

      newSubscriptionListUpdate[updatedSubscriptionIndex].otsList[updatedOtsIndex] = {
        ...newSubscriptionListUpdate[updatedSubscriptionIndex].otsList[updatedOtsIndex],
        [payload.keyName]: payload.value,
        status:
          newSubscriptionListUpdate[updatedSubscriptionIndex].otsList[updatedOtsIndex].status ===
          'CREATED'
            ? 'CREATED'
            : 'UPDATED',
      };

      return {
        ...state,
        subscriptionsList: newSubscriptionListUpdate,
      };

    case PublisherActionTypes.UPDATE_OTS_SUBSCRIPTION:
      const newSubscriptionList = [...state.subscriptionsList];
      const subscriptionIndex = newSubscriptionList.findIndex(
        subscription => subscription.subscriptionId === payload.data.subscriptionId
      );
      newSubscriptionList[subscriptionIndex] = {
        ...newSubscriptionList[subscriptionIndex],
        otsList: payload.data.otsList,
      };

      const updatedsubscriptionsList = JSON.parse(JSON.stringify(newSubscriptionList));
      const updatedBackupSubscriptionList = JSON.parse(JSON.stringify(newSubscriptionList));

      return {
        ...state,
        subscriptionsList: updatedsubscriptionsList,
        backupSubscriptionList: updatedBackupSubscriptionList,
      };

    default:
      return {
        ...state,
      };
  }
};

export const PublisherReducer = combineReducers({
  catalogueManagerState: CatalogueManagerReducer,
  storeManagerState: StoreManagerReducer,
  otsManagerState: OtsManagerReducer,
});
